var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.384,
    height: 11.384,
    viewBox: "0 0 11.384 11.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_223_",
    d: "M15.106,13.764,12.7,11.356A4.752,4.752,0,1,0,11.356,12.7l2.408,2.408a.948.948,0,0,0,1.341-1.341ZM5.423,8.743a3.32,3.32,0,1,1,3.32,3.32A3.324,3.324,0,0,1,5.423,8.743Z",
    transform: "translate(-4 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.87454cf535e7bf246a13fe26d01254ce.svg";
export { ForwardRef as ReactComponent };